import React, {useContext} from 'react';
import {OrdersSadanContext} from "../OrdersSadanContext";
import AddToTableSection from "./AddToTableSection";
import NewTabulator from "../../NewTabulator/NewTabulator";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../../utils/CommaSeparator";
import {deleteRowHandleOrderSadan, updateTableDataOrderSadan, calculateSumOfRowOrderSadan} from "./functions";
import tableCalc from "../../../utils/tableCalc";
import utilsFunction from "../../../utils/utilsFunction";
import numericFunction from "../../../utils/NumericFunction";
import {toast} from "react-toastify";

function FactorJozOrderSadan() {

  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data

  const sumAll = () => {

    const sumOfTable = data.tableData.reduce(
      (accumulator, currentValue) => +accumulator + +currentValue.sum,
      0,
    );

    return sumOfTable + +data.sendPrice - +helper.data?.discountPrice
  }

  const cols = [{field: "uniqId", title: 'یونیک آیدی', visible: false}, {
    field: "rowId", title: 'ردیف', style: {
      width: 50,
      minWidth: 50,
      maxWidth: 50,
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }
  }, {
    field: "productName", title: 'نام محصول', style: {
      width: 250,
      minWidth: 250,
      maxWidth: 250,
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }
  },
    {
      field: "number", title: 'تعداد', editor: "text", style: {
        width: 90,
        minWidth: 90,
        maxWidth: 90,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, cellEdited: (e, cell) => {

        let value = parseToEnRemoveComma(e.target.value);
        value = value.replace(/\D/g, '');


        const field = 'number';
        const uniqId = cell.getData().uniqId;
        updateTableDataOrderSadan({uniqId, value, field, data, setData})
      },

      formatter: tableCalc.persianDigits,
      // bottomCalc: tableCalc.sum,
    },

    {
      field: "weight", title: 'وزن', visible: false, editor: "text", style: {
        width: 100,
        minWidth: 100,
        maxWidth: 100,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, cellEdited: (e, cell) => {
        const productType = cell.getData().productType
        if (productType === "بسته") {
          toast('وزن بسته قابل ویرایش نیست')
          return
        }

        const value = utilsFunction.LimitDotAndThreeCharsAfterDot(e.target.value);

        const field = 'weight';
        const uniqId = cell.getData().uniqId;
        updateTableDataOrderSadan({uniqId, value, field, data, setData})
      },

      formatter: tableCalc.persianDigits,
      // bottomCalc: tableCalc.sum,
    }, {
      field: "totalWeight", title: 'وزن کل', editor: "text", style: {
        width: 100,
        minWidth: 100,
        maxWidth: 100,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, cellEdited: (e, cell) => {
        const value = utilsFunction.LimitDotAndThreeCharsAfterDot(e.target.value);
        const uniqId = cell.getData().uniqId;
        let tableData = [...data.tableData];
        tableData.forEach(row => {
          if (row.uniqId === uniqId) {
            row.totalWeight = value;
            row.mustICalculateTotalWeight = false;
          }
        });
        tableData = calculateSumOfRowOrderSadan(tableData);
        setData({tableData});
        if (parseFloat(value) === 0 || value === '') {
          toast.warn('⚠️ وزن کل صفر وارد شده است');
        }
      },
      formatter: tableCalc.persianDigits,
    }, {
      field: "mustICalculateTotalWeight", title: 'وزن کل ویرایش شده؟', visible: false, formatter: (cell) => {
        return <>{cell.getData().mustICalculateTotalWeight === true ? "خیر" : "بله"}</>
      }
    }, {
      field: "discount", title: 'درصد تخفیف', editor: "text", style: {
        width: 80,
        minWidth: 80,
        maxWidth: 80,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }, cellEdited: (e, cell) => {
        let value = parseToEnRemoveComma(e.target.value);
        value = value.replace(/\D/g, '');

        if (+value > 100 || +value < 0) {
          toast("تخفیف بین 0 تا 100 قابل قبول است")
          return
        }

        const field = 'discount';
        const uniqId = cell.getData().uniqId;
        updateTableDataOrderSadan({uniqId, value, field, data, setData})
      },

      formatter: tableCalc.persianDigits,
      // bottomCalc: tableCalc.sum,
    }, {
      field: "price",
      title: 'قیمت فروش',
      editor: "text",
      style: {display: 'flex', justifyContent: 'center', alignItems: 'center',},
      formatter: tableCalc.separateNumbers,
      cellEdited: (e, cell) => {

        let value = parseToEnRemoveComma(e.target.value);
        value = value.replace(/\D/g, '');


        const field = 'price';
        const uniqId = cell.getData().uniqId;
        updateTableDataOrderSadan({uniqId, value, field, data, setData})
      },
      // bottomCalc: tableCalc.sum,
    },
    {
      field: "sum", title: 'مجموع', style: {
        width: 100, minWidth: 100, maxWidth: 100, display: 'flex', justifyContent: 'center', alignItems: 'center',
      },
      formatter: tableCalc.separateNumbers,
    },

    {
      title: 'حذف', formatter: "buttonCross", style: {
        minWidth: 35, width: 35, maxWidth: 35, display: 'flex', justifyContent: 'center', alignItems: 'center',
      }, cellClick: function (e, cell) {
        console.log(cell.getData().uniqId)
        deleteRowHandleOrderSadan({uniqId: cell.getData().uniqId, data, setData})
      }
    }, // {field:"productId", title:'productId'  , },
  ]


  return (<div>
    <AddToTableSection/>

    <div
      style={{minHeight: "65vh", overflow: "scroll"}}
    >
      <NewTabulator
        columns={cols}
        data={data.tableData}
        // className={"header__orderView__table"}
        className={"header__orderView__table header__color__F1F1F1"}
        //options={tableOptions}
        // options={TabulatorTableOptions.style3}
        style={{height: "65vh", overflowY: 'scroll'}}
        //className={"header__color__F1F1F1"}
      />
    </div>
    <div className="inline-price-tb">
      <p>جمع کل :</p>
      {!isNaN(sumAll()) && formatToPersianAddComma(sumAll())}
    </div>
  </div>)

}

export default FactorJozOrderSadan;